export default __webpack_public_path__ + "img/0d6dc3d7277b1ddb425f0ad7a85e7eba.svg";